import axios from 'axios';

const CUSTOM_TARGETING_API_URL = 'https://keyvalues.rocketgroup.io';

const customTargetingClient = axios.create({
    baseURL: CUSTOM_TARGETING_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor para adicionar token
customTargetingClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Interceptor para tratar erros de autenticação
customTargetingClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Redireciona para login se não autorizado
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default customTargetingClient;